import { StudentExamTimetableTab } from '@features/student-page/sub-features/student-exam-timetable/components/StudentExamTimetableTab'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/students/$studentNo/exam-timetable',
)({
  component: RouteComponent,
  staticData: {
    crumb: {
        label: 'Exam Timetable',
    }
  }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <StudentExamTimetableTab studentNo={studentNo} />
    )
}
